import Vue from "vue";
import CampaignGroupListingTable from "../components/tables/CampaignGroupListingTable";

Vue.component('campaign-groups', {
  components: { CampaignGroupListingTable },
  props: ['vueCampaign', 'vesselId', 'timezone'],
  data() {
    return {
      campaign: JSON.parse(this.vueCampaign),
      vueAppErrors:[]
    }
  },
  methods: {
    onVueAppErrors(errors) {
      this.vueAppErrors = errors;
    }
  }
});
